import { render } from "./GovtBodiesOnboarding.vue?vue&type=template&id=1e22a890&scoped=true&ts=true"
import script from "./GovtBodiesOnboarding.vue?vue&type=script&lang=ts"
export * from "./GovtBodiesOnboarding.vue?vue&type=script&lang=ts"

import "./GovtBodiesOnboarding.vue?vue&type=style&index=0&id=1e22a890&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e22a890"]])

export default __exports__